import { CSVColumnKey } from './types';
import { ColumnFormat, ColumnWidth } from '../google-sheets/googleSheets';

type CurrencyFormatMap = Record<Currency, string>;

const currencyFormats: Partial<CurrencyFormatMap> = {
  EUR: '€#,##0.00',
  GBP: '£#,##0.00',
  ILS: '₪#,##0.00',
  AZN: '₼#,##0.00',
  CZK: '#,#0.00 Kč',
  DKK: '#,##0.00 kr',
  GEL: '₾#,##0.00',
  HUF: 'Ft#,##0.00',
  ISK: 'kr#,##0',
  JPY: '¥#,##0',
  KZT: '₸#,##0.00',
  LTL: 'Lt#,##0.00',
  NOK: '#,##0.00 kr',
  PLN: 'zł#,##0.00',
  SEK: '#,##0.00 kr',
};

const currencyFields: Partial<Record<CSVColumnKey, boolean>> = {
  price: true,
  discounted_price: true,
};

const decimalFields: Partial<Record<CSVColumnKey, string>> = {
  alcohol_percentage: '#0.0',
  vat_percentage: '#0.00',
};

export const getNumberFormats = (currency: Currency, selectedColumns: Partial<CSVColumnKey>[]) => {
  return selectedColumns.reduce<ColumnFormat[]>((acc, key, idx) => {
    if (key) {
      const decimalFormat = decimalFields[key];
      if (decimalFormat) {
        acc.push({ columnIndex: idx, format: decimalFormat, type: 'NUMBER' });
      } else if (currencyFields.hasOwnProperty(key)) {
        const currencyFormat = currencyFormats?.[currency];
        if (currencyFormat) {
          acc.push({ columnIndex: idx, format: currencyFormat, type: 'CURRENCY' });
        }
      }
    }
    return acc;
  }, []);
};

const columnWidths: Partial<Record<CSVColumnKey, number>> = {
  description: 300,
  image_url: 300,
  ingredients: 300,
  nutrition_facts: 300,
  conditions_of_use_and_storage: 300,
  more_information: 300,
  distributor_information: 300,
};

export const getWidths = (selectedColumns: Partial<CSVColumnKey>[]) => {
  return selectedColumns.reduce<ColumnWidth[]>((acc, key, idx) => {
    if (key) {
      const columnWidth = columnWidths[key];
      if (columnWidth) {
        acc.push({ columnIndex: idx, width: columnWidth });
      }
    }
    return acc;
  }, []);
};
